import { Link } from "react-router-dom";
import { Brand } from "@/components/Brand";

export function AccessDeniedPage() {
  return (
    <div className="relative min-h-screen">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -top-32 -left-24 h-[420px] w-[420px] rounded-full bg-danger/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[420px] w-[420px] rounded-full bg-butter/30 blur-3xl" />
      </div>

      <div className="mx-auto flex min-h-screen max-w-[900px] flex-col px-8 py-10">
        <header className="flex items-baseline justify-between">
          <Brand size="md" />
          <div className="text-[0.82rem] text-ink-muted">Status · 403</div>
        </header>

        <div className="flex flex-1 flex-col justify-center">
          <div className="label mb-3">Access denied</div>
          <h1 className="text-[clamp(2.5rem,5vw,4rem)] font-medium tracking-tight text-ink">
            Your account is not on the allowlist.
          </h1>
          <p className="mt-6 max-w-xl text-[1.05rem] leading-relaxed text-ink-soft">
            Contact the administrator to be added. Once your email is
            whitelisted, sign in again and you'll be routed to where you were
            going.
          </p>

          <div className="mt-10">
            <Link
              to="/login"
              className="inline-flex h-12 items-center gap-2 rounded-md bg-primary px-6 text-[1rem] font-medium text-white shadow-soft hover:bg-primary-ink hover:shadow-lift transition-all"
            >
              ← Back to sign-in
            </Link>
          </div>
        </div>

        <footer className="mt-10 border-t border-rule pt-5 text-[0.82rem] text-ink-muted">
          Speedy Expediting · AI1 Assistant · Internal use only
        </footer>
      </div>
    </div>
  );
}
